export type PlanTier = 'free' | 'premium';

export type EntitlementStatus =
  | 'inactive'
  | 'active'
  | 'grace_period'
  | 'cancelled'
  | 'expired';

export type EntitlementProvider = 'manual' | 'stripe' | 'revenuecat' | 'unknown';

export type PlanEntitlement = {
  tier: PlanTier;
  status: EntitlementStatus;
  provider: EntitlementProvider;
  expiresAt?: string;
  updatedAt?: string;
};

/**
 * Free plan limits. Used in UI (e.g. profile "Plan & Access") and in client/server gates.
 *
 * AI recommendation limit: Free users get exactly `aiTripRecommendationsPerMonth` (3) per month.
 * - Client gate: AITravelAssistant calls consumeMonthlyLimit(userId, 'ai_trip_recommendations', 3)
 *   before requesting recommendations; if not allowed, the premium gate modal is shown.
 * - Server gate: Cloud Function consumeUsageLimit enforces the limit in
 *   users/<uid>/usageCounters/ai_trip_recommendations (monthly key); the client cannot bypass it.
 */
export const FREE_PLAN_LIMITS = {
  maxActiveTrips: 1,
  aiTripRecommendationsPerMonth: 3,
  /** Plan tab chatPlanner: each returned suggestion card counts (see Cloud Function chatPlanner). */
  aiPlanIdeaCardsPerMonth: 15,
  /** Fill your day -> Generate AI picks (counted server-side in suggestGapActivities). */
  aiGapActivitySuggestionsPerMonth: 40,
  /** Travel Co-Pilot chat queries counted in travelCompanion callable. */
  aiTravelCompanionQueriesPerMonth: 120,
  emailSyncTripsLifetime: 1,
} as const;

/** Match Cloud Function chatPlanner MIN_SUGGESTIONS / MAX_SUGGESTIONS for client pre-checks. */
export const PLAN_AI_IDEA_BATCH = { min: 5, max: 10 } as const;
